export default {
    bgColor: 0xff3b36,
    primaryKey: "BGElmnts_Shld",
    secondaryKey: "BGElmnts_Cld2",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        image.setScale(data.scaleX, data.scaleY);
        image.alpha = 0;
        let deltaX = 1 - (data.x/bg.scene.size.width);
        image.setPosition(data.x - (350 * deltaX) - 100, data.y - (350 * deltaX) - 100);
        image.angle = data.angle;

        bg.scene.addTween(image, 700, {scaleX: data.scaleX, scaleY: data.scaleY}, "Back");
        bg.scene.addTween(image, 700, {alpha: 1, x: data.x, y: data.y}, Phaser.Math.Easing.Sine.Out);
    },
    animateOut: (image, bg)=>{
        let deltaX = (image.x/bg.scene.size.width);
        bg.scene.addTween(image, 1200, {scaleX: 0, scaleY: 0, alpha: 0, x: image.x + (350 * deltaX) + 200, y: image.y + (350 * deltaX) + 200}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnts_Shld",
            x: 835, y: 549.7706013363029,
            angle: 0,
            scaleX: -1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 465.40290229547566, y: 648.7015590200446,
            angle: 0,
            scaleX: -1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 223.0811442143314, y: 490.19376391982183,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 95, y: 747.3296213808463,
            angle: 0,
            scaleX: -1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 963.7168826423417, y: 291.50334075723833,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 592.543775855094, y: 390.26280623608017,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 353, y: 229.34743875278397,
            angle: 0,
            scaleX: -1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 110.9002596928056, y: 70.12917594654789,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 481.94194104059824, y: -29.28953229398664,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 722.6846494147125, y: 130.57461024498886,
            angle: 0,
            scaleX: -1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: -18.293961816022655, y: 328.2783964365256,
            angle: 0,
            scaleX: -1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 1093.5835127693172, y: 31.051224944320715,
            angle: 0,
            scaleX: -1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 298.63157551318693, y: 21.104677060133632,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 780.6960419684455, y: 340.6726057906459,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 410.37817275444024, y: 440.445434298441,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 648.9894556890995, y: 599.3741648106904,
            angle: 0,
            scaleX: -0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 536.8085711675736, y: 181.1781737193764,
            angle: 0,
            scaleX: -0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 278.52682404833683, y: 697.8708240534521,
            angle: 0,
            scaleX: -0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 40.20506596719258, y: 539.9420935412027,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 166.7802268070835, y: 278.80623608017817,
            angle: 0,
            scaleX: -0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 906.8369155280639, y: 81.24721603563475,
            angle: 0,
            scaleX: -0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 1018.5968497566196, y: 500.74610244988867,
            angle: 0,
            scaleX: -0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 893.2978767829412, y: 760.8819599109131,
            angle: 0,
            scaleX: 0.6499999999999997,
            scaleY: 0.6499999999999997
        },{
            key: "BGElmnts_Shld",
            x: 706.1456106695899, y: 810.6325167037862,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnts_Shld",
            x: 1076.9397225593443, y: 711.3719376391982,
            angle: 0,
            scaleX: 1,
            scaleY: 1
        }
    ]
}